import { createContext, useContext } from "react";

/**
 * Provides an override timezone for all date formatting in the subtree.
 * When set, useFormatDate/useFormatDateTime will use this timezone
 * instead of the browser's local timezone.
 *
 * Value is an IANA timezone string (e.g. "Australia/Perth") or undefined
 * for the browser's local timezone.
 */
const ActiveTimeZoneContext = createContext<string | undefined>(undefined);

export const ActiveTimeZoneProvider = ActiveTimeZoneContext.Provider;

/**
 * Returns the active timezone override, or undefined if using local time.
 */
export function useActiveTimeZone(): string | undefined {
  return useContext(ActiveTimeZoneContext);
}
